<template>
    <div>
        <!-- Title of section and filter show/hide button -->
        <panel-header
            :title="title"
            :toggle-button-value="filterShow"
            @toggleFilterPanel="toggleFilterPanel"
        ></panel-header>

        <!-- Filter section -->
        <toggle-filter-panel v-if="filterShow"
             :filters="filters"
             @filterChange="filterChange"
             @defaultFilterChange="defaultFilterChange"
        ></toggle-filter-panel>

        <br v-if="filterShow" />

        <div class="bg">
            <div class="inner clearfix">
                <data-table
                    :dt-id="'price-analysis-' + type"
                    :my-ajax="dataTableAjax"
                    :columns="columns"
                    :column-defs="columnDefs"
                    :refresh="DTRefresh"
                    on-click-element=".row-details"
                    :on-click-element-event="onClickEvent"
                    :search="{
                        handle: '.dt-df-box',
                        placeholder: t('Name / Index / Ean')
                    }"
                    :search-value="defaultFilter.search"
                    :page-length="defaultFilter.pagination"
                    :sort="false"
                ></data-table>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import DataTable from "../../components/DataTable.vue";
    import dLoader from "./detail.vue";
    import PanelHeader from '../../components/PanelHeader';
    import ToggleFilterPanel from '../../components/ToggleFilterPanel';

    let DetailLoader = Vue.extend(dLoader);

    export default
    {
        props: ['type', 'title'],
        components: {DataTable, PanelHeader, ToggleFilterPanel},
        data()
        {
            let _this = this;
            return {
                filterShow: false,
                showFilterToggleButton: false,
                defaultFilter: {
                    search: '',
                    pagination: 10,
                },
                columns: [],
                filters: {},
                DTRefresh: false,
                columnDefs: [
                {
                    render: function (data, type, row) {
                        let template = '<a href="#" ' +
                            'data-category-id="' + (row['category_id'] ? row['category_id'] : '') + '" ' +
                            'data-custom-category-id="' + (row['custom_category_id'] ? row['custom_category_id'] : '') + '" ' +
                            'data-shop-id="' + (row['shop_id'] ? row['shop_id'] : '') + '" ' +
                            'data-price-type="all" ' +
                            'class="row-details">' +
                            '<span class="glyphicon glyphicon-chevron-down"></span>' + (row['category_name'] ? row['category_name'] : row['custom_category_name'])  + ' (' + row['total_count'] + ')</a>';

                        return template;
                    },
                    targets: [0]
                },{
                    render: function (data, type, row) {
                        return data ? data : '';
                    },
                    targets: [1],
                    visible: _this.type === 0
                },{
                    render: function (data, type, row) {
                        let percent = row['total_count'] > 0 ? row['cheaper_count']/row['total_count'] * 100 : 0;
                        let template = '<a href="#" data-price-type="cheaper" class="row-details green">(' + _this.round(percent) + '%, ' + row['cheaper_count'] + ')</a>';

                        return template;
                    },
                    targets: [2]
                },{
                    render: function (data, type, row) {
                        let percent = row['total_count'] > 0 ? row['same_count']/row['total_count'] * 100 : 0;
                        let template = '<a href="#" data-price-type="same" class="row-details yellow">(' + _this.round(percent) + '%, ' + row['same_count'] + ')</a>';

                        return template;
                    },
                    targets: [3]
                },{
                    render: function (data, type, row) {
                        let percent = row['total_count'] > 0 ? row['expensive_count']/row['total_count'] * 100 : 0;
                        let template = '<a href="#" data-price-type="expensive" class="row-details red">(' + _this.round(percent) + '%, ' + row['expensive_count'] + ')</a>';

                        return template;
                    },
                    targets: [4]
                }],
            };
        },
        mounted()
        {
            this.init();
        },
        computed: {
        },
        methods:
        {
            init()
            {
                let params = {};
                params.type = this.type;
                this.$http.get(this.$route.name + '/init/' + this.type, {params: params}).then(response => {
                    this.columns = response.body.columns;
                    this.showFilterToggleButton = true;
                    this.filters = response.body.filters;
                    this.DTRefresh = !this.DTRefresh;
                });
            },
            dataTableAjax(data, callback)
            {
                delete data.columns;
                this.$buildFilters(this.filters, data);
                data.type = this.type;

                this.$http.get(this.$route.name + '/dt/' + this.type, {params: data}).then((response) => {
                    callback(response.body)
                })
            },
            onClickEvent: function (id, row, e) {
                let tr = $(e.target).closest('tr');
                let td = $(e.target).closest('td');
                let icon = tr.find('.row-details .glyphicon');
                let categoryId = tr.find('.row-details').attr('data-category-id');
                let customCategoryId = tr.find('.row-details').attr('data-custom-category-id');
                let shopId = tr.find('.row-details').attr('data-shop-id');
                let priceType = td.find('.row-details').attr('data-price-type');
                if (row.child.isShown()) {
                    row.child.hide();
                    icon.addClass('glyphicon-chevron-down');
                    icon.removeClass('glyphicon-chevron-up')
                } else {
                    row.child(() => {
                        return '<div class="loading-fragment"><div class="dataTables_processing panel panel-default">'+this.$translate.text('Processing')+'...</div></div>';
                    }).show();
                    let propsData = {
                        forwardedFilters: this.filters,
                        category: categoryId,
                        customCategory: customCategoryId,
                        priceType: priceType,
                        shop: shopId,
                        initUrl: this.$route.name + '/init-detail',
                        dtUrl: this.$route.name + '/dt-detail',
                        dumpUrl: this.$route.name + '/dump-detail',
                    }

                    new DetailLoader({propsData: propsData}).$mount($(row.child()[0]).find('div')[0]);
                }
            },
            round: function(num) {
                return Math.round((num + Number.EPSILON) * 100) / 100;
            },
            toggleFilterPanel: function(filterShow){
                this.filterShow = filterShow;
            },
            filterChange: function(filterName, filterValue, filter) {
                this.DTRefresh=!this.DTRefresh;
            },
            defaultFilterChange: function(defaultFilter) {
                this.defaultFilter = defaultFilter;
            }
        }
    }
</script>


<style lang="sass">
    .green {
        color: forestgreen;
    }
    .yellow {
        color: darkorange;
    }
    .red {
        color: darkred;
    }
</style>


// WEBPACK FOOTER //
// all.vue?71a3d756